import { environmentBase } from "./environment.base";
export const environment = {
	base: environmentBase,
	Evn: "production",
	url: "https://webapps.acep.org/paced/#",
	BaseUrl: "https://webapps.acep.org",
	paymentUrl: "https://webapps.acep.org",
	receiptUrl:
		"https://webapps.acep.org/shoppingcart/printreport.aspx?vw=paced&appid=",
	Token:
		"gNRwvHZZu6TVsFZ4P3QcGQGElZE3+iucrNQlgocJ/2MMftSzZu5tk5h9LSe" +
		"Q2PFnnLifak4aMrq0iTUq4z9+ZoB7NWKIjBHMn/syi4ahFbIfz6IhbvT8WnqF81kLTMWS",
	Promo3To1: "PACED_upgrade3to1",
	Promo3To2: "PACED_upgrade3to2",
	Promo2To1: "PACED_upgrade2to1",
	production: true,
	LogDebug: false,
	LogInfo: false,
	LogError: false,
	images: "./paced/assets/_images/",
	APILocation: "/api/", // APIHost: 'https://pacedapi.acep.org',
	// APIFullPath: 'https://pacedapi.acep.org/api/'
	APIHost: "https://ws.acep.org/pacedapi",
	APIFullPath: "https://ws.acep.org/PACEDAPI/api/",
	PrivateWebServicesBasePath: "https://ws.acep.org"
};



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/environments/environment.ts